import React from 'react';
import HarFileScrubber from './HarFileScrubber';

function App() {
    return (
        <div>
            <HarFileScrubber />
        </div>
    );
}

export default App;